export const CaseDetailDescription = () => {}
